module.exports = __webpack_public_path__ + "static/media/signage-indoor-img54.46e4367e.jpg";